/**
 * Desktop navigacija — logo i glavna traka.
 */
import React from 'react';
import { Link } from 'react-router-dom';

const DesktopNav = ({ homeSectionNavSlot = null }) => (
  <nav role="navigation" aria-label="Главна навигација">
    <div className="header-brand-row">
      <ul className="header-main-nav">
        <li className="header-main-nav-home">
          <h1 className="header-site-title">
            <Link to="/">ПОУ Србија</Link>
          </h1>
        </li>
      </ul>
      {homeSectionNavSlot}
    </div>
  </nav>
);

export default DesktopNav;
